import React from "react";
import styles from "./preloader-bar.module.scss";
import { WithPortal } from "../withPortal/WithPortal";

export const PreloaderBar = () => {
  return (
    <WithPortal>
      <div className={styles.loader}>
        <div className={styles.bar} />
      </div>
    </WithPortal>
  );
};
